<template>
  <div
    class="document-view width-100"
    style="position: relative;">
    <div
      v-if="loadeed !== true && loadeed < 16 && iframe_link "
      class="icon-loaded">
      <sIcon
        class="my-auto mx-auto"
        color="var(--color-main-green)"
        size="40"
        spin
        type="loading"/>
    </div>
    <div
      ref="viewer"
      v-dragscroll="true"
      class="viewer-wrapper">
      <DocumentPdfView
        v-if="pdf_type"
        :url-view="main_link"/>
      <iframe
        v-else-if="!!iframe_link"
        ref="iframe"
        :src="iframe_link"
        @load="load"/>
      <template v-else-if="!!img_link">
        <sAlert
          v-if="imageError"
          class="mx-auto"
          data-qa="image-load-error"
          type="error">
          {{ $t('Common.errorLoadingData') }}
        </sAlert>
        <img
          v-else
          ref="img_viewer"
          :src="img_link"
          @error="imageError = true">
      </template>
      <iframe
        v-else-if="html_type"
        ref="html_viewer"/>
    </div>
  </div>
</template>
<script>
import documentView from 'mixins/documentView'
import DocumentPdfView from 'components/common/elements/DocumentPdfView.vue'

/**
 * Просмотр файлов
 */
export default {
  mixins: [documentView],
  name: 'documentView',
  data() {
    return {
      imageError: false
    }
  }, 
  methods: {
    async openFile() {
      if (this.html_type) {
        this.file.file = await this.file?.downloadFile()
        if ( !this.file.file ) { return }

        let  reader = new FileReader()
        reader.readAsText( this.file.file)
        reader.onload =  (res) => {
          if ( this.$refs.html_viewer ) {
            this.$refs.html_viewer.srcdoc = res.target.result
            this.$refs.html_viewer.style.border = 'none'
            setTimeout(() => {
              if (this.$refs.html_viewer) {
                this.$refs.html_viewer.style.height = this.$refs.html_viewer?.contentWindow?.document?.body?.scrollHeight + 4 + 'px'
              }
            }, 500)
          }
        }
      }
    }
  },
  watch: {
    main_link: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.imageError = false
        this.openFile()
        if (!oldValue || oldValue !== newValue) {
          this.$emit('changeLink')
        }
      }
    }
  },
  components: {
    DocumentPdfView
  }
}
</script>
